<template>
  <div class="chat-circle" @click="$eb.emit('BoxToggle')">
    <!-- <i class="material-icons">forum</i> -->
    <img
      v-if="!isMobile"
      class="lex-circle"
      src="https://storage.googleapis.com/cleed-datacenter-europe/lexception/exception-chat-inactive.svg"
    />
    <!-- <img v-if="!(isMobile && boxOpened)" class="merry-christmas" src="https://storage.googleapis.com/cleed-datacenter-europe/lexception/chatbot-hat.svg"></img> -->
    <img
      v-else-if="isMobile"
      class="lex-circle"
      src="https://storage.googleapis.com/cleed-datacenter-europe/lexception/demilunelex.svg"
    />
    <span
      id="cleed-notifications"
      class="transition"
      style="opacity: 0"
      :style="notification ? 'opacity : 1;' : ''"
    >
      {{ number_notif }}
    </span>
  </div>
</template>

<script>
import utils from "../../utils";
import { customLogger } from "@/utils";

export default {
  name: "ChatCircle",
  data: () => {
    return {
      isMobile: utils.isMobile(),
    };
  },
  computed: {
    boxOpened() {
      return this.$store.state.navigation.boxOpened;
    },
    notification() {
      return this.$store.state.navigation.notification;
    },
    number_notif() {
      const messages = this.$store.state.user.messages;
      let counter = 0;

      for (let idx = messages.length - 1; idx >= 0; idx--) {
        const msg = messages[idx];

        if (msg.sender_type == "bot") ++counter;
        else break;
      }
      return counter;
    },
  },
  mounted() {
    customLogger("mounted second version circle");
  },
};
</script>
